import * as hash_stdlib from "../../stdlib/ts/stdlib";
import { EvalError } from "./EvalError";
import { buildPyodide, globalNamespaces, isPyodideLoaded, runPythonNamespaced, } from "./buildpython";
import { convertToObject } from "./util";
const loadInitializer = async (code, ns) => {
    const wrap = `${code}\nwrap_init(init)`;
    return await runPythonNamespaced(wrap, ns);
};
export const getInitFn = async (fileName, initCode) => {
    const extension = fileName.split(".").pop();
    switch (extension) {
        case "json":
            return (_) => {
                try {
                    const agents = JSON.parse(initCode);
                    if (!Array.isArray(agents)) {
                        throw new Error("must contain an array of agents only");
                    }
                    return agents;
                }
                catch (e) {
                    throw new EvalError(e, fileName);
                }
            };
        case "js":
            const fn = new Function("hash_stdlib", "hstd", `${initCode}\nreturn init`)(hash_stdlib, hash_stdlib);
            return (context) => {
                try {
                    const agents = fn(context);
                    if (!Array.isArray(agents)) {
                        throw new Error("init must return an array of agents");
                    }
                    return agents;
                }
                catch (e) {
                    throw new EvalError(e, fileName);
                }
            };
        case "py":
            if (!isPyodideLoaded()) {
                await buildPyodide();
            }
            const namespace = await globalNamespaces.new("initializer " + fileName);
            try {
                const pyfn = await loadInitializer(initCode, namespace);
                return (_context) => {
                    try {
                        let agents = pyfn();
                        agents = convertToObject(agents.toJs());
                        if (!Array.isArray(agents)) {
                            throw new Error("init must return an array of agents");
                        }
                        return agents;
                    }
                    catch (e) {
                        if (e instanceof EvalError) {
                            throw e;
                        }
                        throw new EvalError(e, fileName, true);
                    }
                };
            }
            catch (e) {
                if (e instanceof EvalError) {
                    throw e;
                }
                throw new EvalError(e, fileName, true);
            }
        default:
            throw new Error(`Unsupported init file '${fileName}'`);
    }
};
//# sourceMappingURL=initializer.js.map